import { selectors, getLabels } from './initialization.js';

const showElement = (element) => {
	element.hidden = false;
};
const hideElement = (element) => {
	element.hidden = true;
};

export const registerEventListener = (searchEl) => {
	const elements = {
		searchInput: searchEl.querySelector(selectors.searchInput),
		clearInput: searchEl.querySelector(selectors.searchClear),
		searchStats: searchEl.querySelector(selectors.searchInputStats),
		searchPageLink: searchEl.querySelector(selectors.searchInputStatsLink),
	};

	// Listener
	const onInputChange = () => {
		// Set delay: Time to wait before results are fetched
		const delay = 200;

		setTimeout(() => {
			const searchTerm = elements.searchInput.value;

			if (searchTerm === '') {
				/**
				 * * Search input field is empty
				 */

				// Add hide class input clear button
				document.querySelector(selectors.searchClear).classList.remove('show');

				// Hide input stats field
				hideElement(elements.searchStats);

				// Clear search results
				searchEl.querySelectorAll(selectors.searchResultsSegment).forEach((segment) => {
					segment.innerHTML = '';
				});
			} else {
				/**
				 * * User has searched for something
				 */

				// Show input clear button
				document.querySelector(selectors.searchClear).classList.add('show');
				// Show input stats field
				showElement(elements.searchStats);

				/**
				 * Calculate amount of results
				 */
				let totalResults = 0;
				let hasResults = false;
				let hasHiddenResults = false;

				const searchResultsSegments = searchEl.querySelectorAll(selectors.searchResultsSegment);
				searchResultsSegments.forEach((segment) => {
					// Get max shown results for each segment
					const dataResultCount = segment.getAttribute('data-result-count');
					let segmentResultLimit = dataResultCount ? parseInt(dataResultCount) : 0;

					const hitsEl = segment.querySelector(selectors.searchHits);
					const segmentHits = hitsEl ? parseInt(hitsEl.getAttribute('data-hits')) : 0;

					// Check if segment has any results at all
					if (segmentHits && segmentHits > 0) {
						hasResults = true;
						totalResults += segmentHits;

						// Check if segment has more results that it would show
						if (segmentResultLimit && segmentHits > segmentResultLimit) {
							hasHiddenResults = true;
						}
					}
				});

				// Handle search result status message
				let label;
				if (!hasResults) {
					label = getLabels('no_results');
				} else {
					label = getLabels('result_count')[totalResults > 1 ? 'multiple' : 'one'].replace('%d', totalResults);
				}
				searchEl.querySelector(selectors.searchInputStatsCount).textContent = label;

				// Handle appearance of link to a search results page
				const serpBaseUrl = searchEl.getAttribute('data-serp');
				if (hasHiddenResults && serpBaseUrl !== '') {
					const url = new URL(serpBaseUrl);
					url.searchParams.append('s', searchTerm);
					searchEl.querySelector(selectors.searchInputStatsLink).setAttribute('href', url.href);
					showElement(elements.searchPageLink);
				} else {
					hideElement(elements.searchPageLink);
				}
			}
		}, delay);
	};

	// Add Event Listener for two event types
	elements.searchInput.addEventListener('input', onInputChange);
	elements.searchInput.addEventListener('change', onInputChange);

	// Manual one-time trigger
	setTimeout(() => {
		elements.searchInput.dispatchEvent(new Event('change'));
	}, 250);

	// Input clearance
	elements.clearInput.addEventListener('click', () => {
		// Clear input field
		elements.searchInput.value = '';
		elements.searchInput.dispatchEvent(new Event('change'));
	});
};
